const dobElement = document.querySelector('#dob');
if (dobElement && typeof Datepicker === "function") {
  new Datepicker(dobElement, {
    format: 'dd-mm-yyyy'
  });
}

const GM_CALCULATOR_SOURCE = "rudraksha_calculator";
let gmCalculatorFunnelId = "";

function gmCreateCalculatorFunnelId() {
  const randomPart =
    window.crypto && typeof window.crypto.randomUUID === "function"
      ? window.crypto.randomUUID()
      : Math.random().toString(36).slice(2) + Date.now().toString(36);

  gmCalculatorFunnelId = `gmcalc_${Date.now().toString(36)}_${randomPart}`;

  try {
    window.sessionStorage.setItem(
      "gm_calculator_funnel_id",
      gmCalculatorFunnelId
    );
  } catch (error) {
    // Session storage can be unavailable in privacy-restricted browsers.
  }

  return gmCalculatorFunnelId;
}

function gmGetCalculatorFunnelId() {
  if (gmCalculatorFunnelId) return gmCalculatorFunnelId;

  try {
    const storedId = window.sessionStorage.getItem(
      "gm_calculator_funnel_id"
    );
    if (storedId) {
      gmCalculatorFunnelId = storedId;
      return storedId;
    }
  } catch (error) {
    // Fall through to an in-memory ID.
  }

  return gmCreateCalculatorFunnelId();
}

function gmTrackCalculatorEvent(eventName, details = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    gm_calculator_funnel_id: gmGetCalculatorFunnelId(),
    gm_calculator_source: GM_CALCULATOR_SOURCE,
    ...details,
  });
}

function gmAttachCalculatorCartAttribution(funnelId) {
  return fetch("/cart/update.js", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "same-origin",
    keepalive: true,
    body: JSON.stringify({
      attributes: {
        gm_calculator_funnel_id: funnelId,
        gm_calculator_source: GM_CALCULATOR_SOURCE,
      },
    }),
  }).then((response) => {
    if (!response.ok) {
      throw new Error("Calculator cart attribution failed");
    }
    return response.json();
  });
}

function gmOpenRecommendedProduct(product, productIndex, resultCount) {
  if (!product || !product.url) return;

  const funnelId = gmGetCalculatorFunnelId();
  const productUrl = new URL(product.url, window.location.origin);

  if (productUrl.origin === window.location.origin) {
    productUrl.searchParams.set("gm_calc_id", funnelId);
  }

  gmTrackCalculatorEvent("rudraksha_calculator_product_click", {
    product_index: productIndex + 1,
    result_count: resultCount,
    product_path: productUrl.pathname,
  });

  const productWindow = window.open("about:blank", "_blank");
  if (productWindow) {
    try {
      productWindow.opener = null;
    } catch (error) {
      // Navigation still works if the browser blocks opener changes.
    }
  }

  const attributionRequest = gmAttachCalculatorCartAttribution(funnelId).catch(
    () => null
  );
  const navigationTimeout = new Promise((resolve) =>
    window.setTimeout(resolve, 500)
  );

  Promise.race([attributionRequest, navigationTimeout]).finally(() => {
    if (productWindow) {
      productWindow.location.href = productUrl.toString();
    } else {
      window.location.href = productUrl.toString();
    }
  });
}

function gmBindRecommendedProductLinks(products) {
  document
    .querySelectorAll(".product-link[data-gm-product-index]")
    .forEach((button) => {
      const productIndex = Number(button.dataset.gmProductIndex);
      button.addEventListener("click", () => {
        gmOpenRecommendedProduct(
          products[productIndex],
          productIndex,
          products.length
        );
      });
    });
}

gmTrackCalculatorEvent("rudraksha_calculator_view", {
  page_path: window.location.pathname,
});

const phoneInput = document.getElementById("phone");
const phoneError = document.getElementById("phone-error");
const countryCodeSelect = document.getElementById("country-code");
const formStatus = document.getElementById("form-status");
const DEFAULT_PHONE_RULE = { min: 6, max: 15 };
const RUDRAKSHA_PROXY_ENDPOINT = "/apps/gm-rudraksha";
const RUDRAKSHA_API_ENDPOINT = "https://api.astroarunpandit.org/verified-rudraksha-info";
const RUDRAKSHA_API_KEY = "PWVN7FhSdp1mRbokpRbwl7sl9NBk9vkO40ki8UJK";
const RUDRAKSHA_SOURCE_TYPE = "gems_web";
const PHONE_RULES_BY_COUNTRY = {
  IN: { min: 10, max: 10 },
  AU: { min: 9, max: 10 },
};

function normalizeDialCode(phoneCode) {
  const primaryCode = String(phoneCode || "").split(/\s+(?:and|or)\s+|,|\/|;/i)[0];
  const digits = primaryCode.replace(/\D/g, "");
  return digits ? `+${digits}` : "";
}

function getSelectedCountryOption() {
  if (!countryCodeSelect) return null;
  return countryCodeSelect.options[countryCodeSelect.selectedIndex] || null;
}

function getSelectedPhoneRule() {
  const selectedOption = getSelectedCountryOption();
  const countryIso = selectedOption?.dataset.countryIso || "";
  return PHONE_RULES_BY_COUNTRY[countryIso] || DEFAULT_PHONE_RULE;
}

function getPhoneValidationMessage() {
  const selectedOption = getSelectedCountryOption();
  const selectedRule = getSelectedPhoneRule();
  const countryName = selectedOption?.dataset.countryName || "this country";

  if (selectedRule.min === selectedRule.max) {
    return `Phone number must be ${selectedRule.max} digits for ${countryName}.`;
  }

  return `Phone number must be between ${selectedRule.min} and ${selectedRule.max} digits for ${countryName}.`;
}

function setFormStatus(message, isError = false) {
  if (!formStatus) return;

  formStatus.textContent = message || "";
  formStatus.hidden = !message;
  formStatus.classList.toggle("is-error", Boolean(message) && isError);
}

function isPhoneValid(phoneNumber) {
  const selectedRule = getSelectedPhoneRule();
  const digitsOnly = String(phoneNumber || "").replace(/\D/g, "");
  return digitsOnly.length >= selectedRule.min && digitsOnly.length <= selectedRule.max;
}

function updatePhoneErrorState() {
  if (!phoneInput || !phoneError) return true;

  const digitsOnly = phoneInput.value.replace(/\D/g, "");
  const isValid = digitsOnly !== "" && isPhoneValid(digitsOnly);
  const message = isValid ? "" : getPhoneValidationMessage();

  phoneError.textContent = message || "Please enter a valid mobile number";
  phoneError.style.display = message ? "block" : "none";
  phoneInput.setCustomValidity(message);

  return isValid;
}

function applyPhoneValidationRule() {
  if (!phoneInput) return;

  const selectedRule = getSelectedPhoneRule();
  const digitsOnly = phoneInput.value.replace(/\D/g, "").slice(0, selectedRule.max);

  phoneInput.value = digitsOnly;
  phoneInput.maxLength = selectedRule.max;
  phoneInput.minLength = selectedRule.min;

  if (phoneError) {
    phoneError.style.display = "none";
    phoneError.textContent = "Please enter a valid mobile number";
  }

  phoneInput.setCustomValidity("");
}

function parseRecommendationResponse(response) {
  if (!response.ok) {
    throw new Error("Calculator recommendation request failed");
  }

  return response.json().then((data) => {
    if (data && data.status === "error") {
      throw new Error(
        data.details || data.message || "Calculator recommendation request failed"
      );
    }

    return data;
  });
}

function fetchRecommendationFromProxy(requestPayload) {
  return fetch(RUDRAKSHA_PROXY_ENDPOINT, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestPayload),
    cache: "no-store",
    credentials: "same-origin",
  }).then(parseRecommendationResponse);
}

function fetchRecommendationFromDirectApi(requestPayload) {
  const fallbackPayload = new URLSearchParams({
    full_name: requestPayload.full_name || "",
    birth_date: requestPayload.birth_date || "",
    birth_time: requestPayload.birth_time || "",
    birth_place: requestPayload.birth_place || "",
    birth_lat: requestPayload.birth_lat || "",
    birth_long: requestPayload.birth_long || "",
    user_email: requestPayload.user_email || "",
    user_number: requestPayload.user_number || "",
    chart_type: requestPayload.chart_type || "",
    country_code: requestPayload.country_code || "",
    purpose: requestPayload.purpose || "",
    source_type: RUDRAKSHA_SOURCE_TYPE,
  });

  return fetch(`${RUDRAKSHA_API_ENDPOINT}?${fallbackPayload.toString()}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "x-api-key": RUDRAKSHA_API_KEY,
    },
    cache: "no-store",
  }).then(parseRecommendationResponse);
}

function fetchRudrakshaRecommendation(requestPayload) {
  return fetchRecommendationFromProxy(requestPayload).catch((proxyError) => {
    console.warn(
      "[GemsMantra] Rudraksha proxy request failed. Falling back to direct API.",
      proxyError
    );
    return fetchRecommendationFromDirectApi(requestPayload);
  });
}

const countryData = "https://cdn.shopify.com/s/files/1/0648/0514/2781/files/country_code_and_details.json";

fetch(countryData)
  .then((response) => {
    if (!response.ok) {
      throw new Error("Network response was not ok " + response.statusText);
    }
    return response.json();
  })
  .then((data) => {
    while (document.getElementById("country-code").options.length > 0) {
      document.getElementById("country-code").remove(0);
    }

    const countries = data.countries || [];
    const selectBox = document.getElementById("country-code");

    countries.forEach((country) => {
      const dialCode = normalizeDialCode(country.phone_code);

      if (!dialCode) {
        return;
      }

      const option = document.createElement("option");
      option.value = dialCode;
      option.textContent = `${country.country_code} (${dialCode})`;
      option.dataset.countryIso = country.country_code;
      option.dataset.countryName = country.country_name || country.country_code;

      if (country.country_code === "IN") {
        option.selected = true;
      }

      selectBox.appendChild(option);
    });

    applyPhoneValidationRule();
  })
  .catch((error) => {
    console.error("[GemsMantra] Country data could not be loaded.");
  });

let map;
let manager;
let lat = "22.572645",
  longs = "88.363892",
  locationOn = false,
  selectedLoc;

function renderProducts(products) {
  const productListContainer = document.getElementById("productList");
  productListContainer.innerHTML = "";

  if (products.length === 1) {
    // If there is only one product
    const product = products[0];
    productListContainer.innerHTML = `
        <div class="product-item">
          <div class="product-item-image">
            <img src="${product.image}" alt="${product.name}" class="product-image" />
          </div>
          <h3>${product.name}</h3>
          <button class="product-link" data-gm-product-index="0">Buy Now</button>
        </div>
      `;
  } else if (products.length === 2) {
    // If there are exactly two products, add "or" in between
    const productItemsHTML = products
      .map(
        (product, index) => `
          <div class="product-item">
            <div class="product-item-image">
              <img src="${product.image}" alt="${product.name}" class="product-image" />
            </div>
            <h3>${product.name}</h3>
            <button class="product-link" data-gm-product-index="${index}">Buy Now</button>
          </div>
          ${index === 0 ? '<div class="multiple">OR</div>' : ""}
        `
      )
      .join("");

    productListContainer.innerHTML = productItemsHTML;
  } else {
    const productItemsHTML = products
      .map(
        (product, index) => `
          <div class="product-item">
            <div class="product-item-image">
              <img src="${product.image}" alt="${product.name}" class="product-image" />
            </div>
            <h3>${product.name}</h3>
            <button class="product-link" data-gm-product-index="${index}">Buy Now</button>
          </div>
        `
      )
      .join("");

    productListContainer.innerHTML = `
        ${productItemsHTML}
        <div class="existing">Existing</div>
      `;
  }

  gmBindRecommendedProductLinks(products);

  const productListWrapper = document.querySelector(".product-list-wrapper");
  const bannerContainer = document.querySelector(".rudraksh-banner-container");
  const loader = document.getElementById("loader");

  if (productListWrapper) {
    productListWrapper.style.display = "block";
  }

  if (bannerContainer) {
    bannerContainer.style.display = "flex";
  }

  if (loader) {
    loader.style.display = "none";
  }

  setFormStatus("Your Rudraksha recommendation is ready.");
}

function selectedSuggestion(suggestionResult) {
  if (!manager) return;

  lat = suggestionResult?.location?.latitude;
  longs = suggestionResult?.location?.longitude;
  selectedLoc = suggestionResult?.formattedSuggestion;
  locationOn = true;
}

const displaySuggestions = (suggestions) => {
  const suggestionsList = document.getElementById("suggestions");
  suggestionsList.innerHTML = "";
  suggestions.forEach((suggestion) => {
    const listItem = document.createElement("li");
    listItem.textContent = `${suggestion.address}`;
    listItem.setAttribute("lat", suggestion.coordinates[0]);
    listItem.setAttribute("lon", suggestion.coordinates[1]);
    listItem.addEventListener("click", function () {
      const s_box = document.getElementById("searchBox");
      s_box.value = suggestion.address;
      s_box.setAttribute("lat", suggestion.coordinates[0]);
      s_box.setAttribute("lon", suggestion.coordinates[1]);
      s_box.setAttribute("selected", suggestion.address);
      document.getElementById("suggestions").innerHTML = "";
    });
    listItem.style.cursor = "pointer";
    suggestionsList.appendChild(listItem);
  });
};

const primaryKey = "ubcsy6zDJKyVgIsyHOU3cDJsIIJq4c6AaxWUyZlZD325czV845OAJQQJ99AKACYeBjFqAWCNAAAgAZMP3A5E";

document.getElementById("searchBox").addEventListener("input", function (event) {
  const fetchSuggestions = async () => {
    var mapValue = document.getElementById("searchBox").value;
    if(mapValue.length > 3) {
      try {
        // const response = await fetch(`https://api.mapbox.com/search/geocode/v6/forward?q=${document.getElementById("searchBox").value}&proximity=ip&access_token=pk.eyJ1IjoiZGl2eWFuc2h1a21yOTEiLCJhIjoiY21hM2pyenp4MjQ4czJvc2dnOTlhcW11diJ9.YO1a_xIwfA2m4dJdx3RtKg`);
        const response = await fetch(`https://api-geocode.obrio.net/v1/autocomplete?text=${document.getElementById("searchBox").value}`);
        if (!response.ok) {
          throw new Error("Failed to fetch suggestions");
        }
        const data = await response.json();

        // Map Box API
        /*const suggestions = data.features.map((result) => ({
          address: result.properties.full_address,
          coordinates: [result.properties.coordinates.latitude, result.properties.coordinates.longitude],
        }));
        console.log(suggestions);*/

        // OpenSource API
        const suggestions = data.features.map((result) => ({
          address: `${result.properties.name}, ${result.properties.region}, ${result.properties.country}`,
          coordinates: [result.geometry.coordinates[1], result.geometry.coordinates[0]],
        }));
        displaySuggestions(suggestions);
      } catch (error) {
        console.error("[GemsMantra] Location suggestions could not be loaded.");
      }
    }
  };

  fetchSuggestions();
});

document.getElementById("astrologyForm").addEventListener("submit", function (event) {
  event.preventDefault();
  setFormStatus("");

  const nameInput = document.getElementById("full_name").value.trim();
  if (nameInput === "") {
    setFormStatus("Name is required.", true);
    alert("Name is required.");
    return;
  }

  if (nameInput.length < 3) {
    setFormStatus("Please enter a valid name.", true);
    alert("Please Enter Valid Name");
    return;
  }

  const namePattern = /^[a-zA-Z\s'-]+$/;
  if (!namePattern.test(nameInput)) {
    setFormStatus("Name contains invalid characters.", true);
    alert("Name contains invalid characters.");
    return;
  }

  // const emailInput = document.getElementById("email").value;
  // console.log(emailInput);
  // const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  // if(emailRegex.test(email)) {
  //   alert("Please Enter a valide E-Mail address");
  //   return;
  // }

  if (phoneInput) {
    phoneInput.value = phoneInput.value.replace(/\D/g, "");
  }

  if (!phoneInput || !isPhoneValid(phoneInput.value)) {
    setFormStatus(getPhoneValidationMessage(), true);
    updatePhoneErrorState();
    alert(getPhoneValidationMessage());
    phoneInput?.focus();
    return;
  }

  const dateInput = document.getElementById("dob").value;
  const invalidYearRegex = /^0\d{3}-\d{2}-\d{2}$/;
  if (invalidYearRegex.test(dateInput)) {
    setFormStatus("Please enter a valid date.", true);
    alert("Please enter a valid date");
    return;
  }

  if (document.getElementById("searchBox").getAttribute("selected") != document.getElementById("searchBox").value) {
    // console.log(document.getElementById("searchBox").getAttribute("selected"), document.getElementById("searchBox").value)
    setFormStatus("Please select the place of birth from the suggestions.", true);
    alert("Please fill correct location");
    return;
  }

  document.getElementById("loader").style.display = "block";
  setFormStatus("Checking your Rudraksha recommendation...");

  let map;

  const selectedPurpose = document.getElementById("purpose").value;
  const searchBox = document.getElementById("searchBox");

  const formData = new FormData(this);
  const chartType = formData.get("chart_type") || "";

  gmCreateCalculatorFunnelId();
  gmTrackCalculatorEvent("rudraksha_calculator_submit", {
    chart_type: String(chartType),
    purpose:
      chartType === "purpose" ? String(selectedPurpose) : "not_applicable",
  });

  var birthDate = formData.get("dob");
  let dateArr = birthDate.split("-");
  let formattedDate = `${dateArr[2]}-${dateArr[1]}-${dateArr[0]}`;
  const requestPayload = {
    full_name: formData.get("full_name"),
    birth_date: formattedDate,
    birth_time: document.querySelector('input[name="time-input"]').checked ? "" : formData.get("birth_time"),
    birth_place: searchBox.getAttribute("selected"),
    birth_lat: searchBox.getAttribute("lat"),
    birth_long: searchBox.getAttribute("lon"),
    user_email: formData.get("email"),
    user_number: phoneInput ? phoneInput.value.replace(/\D/g, "") : formData.get("phone"),
    chart_type: formData.get("chart_type"),
    country_code: formData.get("country_code"),
    purpose: formData.get("purpose")
  };
  fetchRudrakshaRecommendation(requestPayload)
    .then((data) => {
      const products = Array.isArray(data?.result) ? data.result : [];
      if (!products.length) {
        setFormStatus(
          "No Rudraksha recommendation was returned for these details.",
          true
        );
        document.getElementById("loader").style.display = "none";
        return;
      }

      gmTrackCalculatorEvent("rudraksha_calculator_result", {
        result_count: products.length,
      });
      renderProducts(products);
    })
    .catch((error) => {
      gmTrackCalculatorEvent("rudraksha_calculator_error", {
        stage: "recommendation_api",
      });
      console.error("[GemsMantra] Rudraksha calculation request failed.");
      document.getElementById("loader").style.display = "none";
      setFormStatus(
        error?.message ||
          "We couldn't fetch your Rudraksha recommendation right now. Please try again.",
        true
      );
    });
});

document.querySelector('input[name="time-input"]').addEventListener("change", () => {
  if (document.querySelector('input[name="time-input"]').checked) {
    document.querySelector("#birth_time").disabled = true;
    document.getElementById("hours").disabled = true;
    document.getElementById("minutes").disabled = true;
    document.getElementById("ampm").disabled = true;
    document.querySelector(".time-input-wrapper").classList.remove("active");
  } else {
    document.querySelector("#birth_time").disabled = false;
    document.getElementById("hours").disabled = false;
    document.getElementById("minutes").disabled = false;
    document.getElementById("ampm").disabled = false;
    document.querySelector(".time-input-wrapper").classList.add("active");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const hoursDropdown = document.getElementById("hours");
  const minutesDropdown = document.getElementById("minutes");
  const ampmDropdown = document.getElementById("ampm");
  const hiddenInput = document.getElementById("birth_time");

  function updateHiddenTime() {
    const hours = parseInt(hoursDropdown.value, 10);
    const minutes = minutesDropdown.value;
    const ampm = ampmDropdown.value;

    let hours24 = hours;
    if (ampm === "PM" && hours !== 12) {
      hours24 += 12;
    } else if (ampm === "AM" && hours === 12) {
      hours24 = 0;
    }
    const formattedHours = hours24.toString().padStart(2, "0");
    const time = `${formattedHours}:${minutes}`;
    hiddenInput.value = time;
  }

  hoursDropdown.addEventListener("change", updateHiddenTime);
  minutesDropdown.addEventListener("change", updateHiddenTime);
  ampmDropdown.addEventListener("change", updateHiddenTime);

  if (phoneInput) {
    phoneInput.addEventListener("input", applyPhoneValidationRule);
    phoneInput.addEventListener("blur", updatePhoneErrorState);
    applyPhoneValidationRule();
  }

  if (countryCodeSelect) {
    countryCodeSelect.addEventListener("change", applyPhoneValidationRule);
  }

  const chartTypeElement = document.querySelector('[name="chart_type"]');
  if (chartTypeElement) {
    chartTypeElement.addEventListener("change", function () {
      const selectedValue = chartTypeElement.value;

      const birthLuckNote = document.getElementById("birth-luck-note");
      const purposeNote = document.getElementById("purpose-note");
      const purposeSelect = document.getElementById("purpose");
      const purposeLabel = document.getElementById("purposeLabel");

      if (selectedValue === "purpose") {
        birthLuckNote.style.display = "none";
        purposeNote.style.display = "block";
        purposeSelect.style.display = "block";
        purposeLabel.style.display = "block";
      } else {
        birthLuckNote.style.display = "block";
        purposeNote.style.display = "none";
        purposeSelect.style.display = "none";
        purposeLabel.style.display = "none";
      }
    });
  }
});
